<template>
    <div style="height: 100%;display: flex;flex-direction: column;background: #F9F9F9;">
        <div style="height: 96px;padding:38px 16px 0">
            <div @click="goBack" style="line-height: 48px;display: inline-block;">
                <a-icon style="color:rgba(4, 4, 4, 1);font-size: 16px;margin-right: 11px;" type="left" />
                <span style="color:rgba(44, 54, 74, 1);font-size:15px;">短信发送</span>
            </div>
        </div>
        <div style="flex: 1;overflow-y: auto;position: relative;padding-bottom: 24px;">
            <div style="padding:0 16px">
                <div style="height: 204px;background: #fff;border-radius: 8px;padding:12px 16px;">
                    <div style="color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">选择模版</div>
                    <div style="margin-top:12px">
                        <div class="mine-share">
                            <span @click="selectType(1)" :class="{'active':msgTplSign==1}">我的</span>
                            <span @click="selectType(2)" :class="{'active':msgTplSign==2}">共享</span>
                        </div>
                    </div>
                    <a-select v-model="tplSelected" placeholder="请选择" style="width: 100%;margin-top:8px;" @change="changeTpl">
                        <a-select-option :value="item.id" v-for="(item,index) in magTplList" :key='index'>
                            <div v-html="item.templateContent"></div>
                        </a-select-option>
                    </a-select>
                    <div style="height: 64px;overflow-y: auto;margin-top:12px;">
                        <div v-html="selectedHtml"></div>
                    </div>
                </div>
                <div style="margin-top:16px;padding:12px 16px;background:#fff">
                    <div style="color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">输入号码</div>
                    <div style="margin-top:12px">
                        <a-textarea placeholder="请输入" v-model.trim="dataValue" style="min-height: 200px;border: 1px solid rgba(121, 136, 155, 0.3);resize: none;" />
                    </div>
                </div>
            </div>
        </div>
        <div style="position: fixed;height: 40px;width:100%;left:0;bottom:20px;padding: 0 16px;">
            <div @click="sendMsg" style="width:100%;height: 40px;border-radius: 8px;box-shadow: 2px 2px 19px 0px rgba(66, 223, 228, 0.2);text-align: center;line-height: 40px;background: rgba(66, 223, 228, 1);color:#fff;font-size: 15px;">
                <span>确认</span>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'MobileSend',
        props: {
            msg: String
        },
        data() {
            return {
                tplSelected: undefined,
                magTplList: [],
                msgTplSign: 1,
                hasVar: '',
                dataValue: '',
                selectedHtml: '',
                batchId: '',
                dataList: [],
            } 
        },

        methods: {
            goBack() {
                this.$router.push("/MobileRecord")
            },
            selectType(type) {
                this.tplSelected = undefined
                this.msgTplSign = type
                this.hasVar = ''
                this.selectedHtml = ''
                this.queryMsgTpl()
            },
            queryMsgTpl() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/templateManagement/selectList', 
                        params: {
                            shareStatus: this.msgTplSign,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        this.magTplList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeTpl(value) {
                const item = this.magTplList.find(i => i.id === value)
                const hasVar = item ? item.hasVar : false
                this.hasVar = hasVar
                this.selectedHtml = item.templateContent
                // console.log(this.tplSelected)
                
                this.$forceUpdate()
            },
            sendMsg() {
                if(this.dataValue!=''){
                    this.dataList = this.dataValue.split('\n');
                    this.axios.post('/api/smsRecord/addConstantSms', {
                        batchId: this.batchId,
                        smsTemplateId: this.tplSelected,
                        phoneList: this.dataList,
                    })
                    .then(response=> {
                        if(response.data.code == 0){
                            this.$message.success('提交成功');
                            this.tplSelected = undefined
                            this.dataValue = ''
                            this.selectedHtml = ''
                        }else{
                            this.$message.error(response.data.userTip);
                        }
                    })
                    .catch(error=> {
                        console.log(error);
                    });
                }
            },
            queryBatchId() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/smsRecord/batchNumber', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.batchId = response.data.data.batchId
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
        },
        mounted: function() {
            this.queryMsgTpl()
            this.queryBatchId()
        }
    }
</script>

<style scoped lang="less">
    .mine-share{
        display: inline-block;
        width: 126px;
        height:28px;
        background: #E8E9EC;
        border-radius: 8px;
        padding: 3px;
        span{
            display: inline-block;
            height: 22px;
            line-height: 22px;
            width: 60px;
            text-align: center;
            color: rgba(103, 110, 125, 1);
            font-size: 12px;
        }
        span.active{
            background: #fff;
            border-radius: 6px;
            color: rgba(44, 54, 74, 1);
            font-size: 12px;
            font-weight: bold;
        }
    }
</style>
  